// src/api/panels.ts

import api from '@/lib/axios';
import type {
  PanelTemplate,
  UploadPanelRequest,
  // UpdatePanelRequest,
  AssociateProductRequest,
} from '@/types/panel';

/**
 * 上传新面板
 * POST /v1/developer/panels
 * @param panelData - 面板数据（name, version）
 * @param file - 面板文件
 */
export const uploadPanel = (
  panelData: Pick<UploadPanelRequest, 'name' | 'version'>,
  file: File
): Promise<PanelTemplate> => {
  const formData = new FormData();
  formData.append('name', panelData.name);
  formData.append('version', panelData.version);
  formData.append('file', file);
  return api.post('/developer/panels', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * 获取面板列表
 * GET /v1/developer/panels
 */
export const getPanels = (): Promise<PanelTemplate[]> => {
  return api.get('/developer/panels');
};

/**
 * 获取面板详情
 * GET /v1/developer/panels/{panel_id}
 * @param panelId - 面板 ID
 */
export const getPanel = (panelId: string): Promise<PanelTemplate> => {
  return api.get(`/developer/panels/${panelId}`);
};

/**
 * 删除面板
 * DELETE /v1/developer/panels/{panel_id}
 * @param panelId - 面板 ID
 */
export const deletePanel = (panelId: string): Promise<void> => {
  return api.delete(`/developer/panels/${panelId}`);
};

// /**
//  * 升级面板（覆盖版本）
//  * POST /v1/developer/panels/{panel_id}/update
//  * @param panelId - 面板 ID
//  * @param updateData - 新版本和文件
//  */
// export const updatePanel = (
//   panelId: string,
//   updateData: UpdatePanelRequest
// ): Promise<PanelTemplate> => {
//   const formData = new FormData();
//   formData.append('version', updateData.version);
//   formData.append('file', updateData.file);
//   return api.post(`/developer/panels/${panelId}/update`, formData, {
//     headers: { 'Content-Type': 'multipart/form-data' },
//   });
// };

/**
 * 自动关联产品（根据面板类型）
 * POST /v1/developer/panels/{panel_id}/products
 * @param panelId - 面板 ID
 * @param associationData - 产品关联数据
 */
export const associateProduct = (
  panelId: string,
  associationData: AssociateProductRequest
): Promise<void> => {
  return api.post(`/developer/panels/${panelId}/products`, associationData);
};

/**
 * 显式关联 iOS 产品
 * POST /v1/developer/panels/{panel_id}/products/ios
 * @param panelId - 面板 ID
 * @param associationData - 产品关联数据
 */
export const associateIOSProduct = (
  panelId: string,
  associationData: AssociateProductRequest
): Promise<void> => {
  return api.post(`/developer/panels/${panelId}/products/ios`, associationData);
};

/**
 * 显式关联 Android 产品
 * POST /v1/developer/panels/{panel_id}/products/android
 * @param panelId - 面板 ID
 * @param associationData - 产品关联数据
 */
export const associateAndroidProduct = (
  panelId: string,
  associationData: AssociateProductRequest
): Promise<void> => {
  return api.post(`/developer/panels/${panelId}/products/android`, associationData);
};

// src/api/panels.ts

// // ✅ 在文件末尾添加升级面板 API (修正版本)
// interface APIError extends Error {
//   response?: {
//     data?: {
//       message?: string;
//       code?: number;
//     };
//   };
// }

/**
 * 升级面板（覆盖旧版本）
 * POST /v1/developer/panels/{panel_id}/update
 * @param panelId - 面板 ID
 * @param version - 新版本号
 * @param file - 新面板文件
 */
export const updatePanel = (
  panelId: string,
  version: string,
  file: File
): Promise<PanelTemplate> => {
  const formData = new FormData();
  formData.append('version', version);
  formData.append('file', file);

  return api.post(`/developer/panels/${panelId}/update`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};